"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerHistorial = void 0;
var React = require("react");
var FetchAnuncios_1 = require("./FetchAnuncios");
var reactstrap_1 = require("reactstrap");
var reactstrap_2 = require("reactstrap");
//import imgAnuncio from "./img-anuncio.JPG";
var url_js_1 = require("../variables/url.js");
var io5_1 = require("react-icons/io5");
var espolAds_1 = require("../variables/espolAds");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var anuncio = localBack + 'api/Catalog/Anuncios/';
var revisor = localBack + 'api/catalog/revisor/';
var historial = localBack + 'api/catalog/anuncios/historial/';
var historialRev = localBack + 'api/catalog/revisor/historialRev/';
var VerHistorial = /** @class */ (function (_super) {
    __extends(VerHistorial, _super);
    function VerHistorial(props) {
        var _this = _super.call(this, props) || this;
        _this.abrirModal = function (id, estado, idSec) {
            if (estado == 'R')
                _this.setState({ abierto: !_this.state.abierto, idTarget: id, TargetSeg: _this.state.seguimientoList.filter(function (x) { return x.idSecuencia == idSec; })[0].txObservacion });
            //console.log(this.state.idTarget);
            //console.log(idSec);
            //console.log(this.state.TargetSeg);
        };
        _this.cerrarModal = function () {
            _this.setState({ abierto: !_this.state.abierto, idTarget: 0 });
            /*console.log(this.state.idTarget);*/
        };
        _this.state = { title: "", loading: true, status: 0, visor: '', abierto: false, visible: true, idTarget: 0, TargetSeg: '', dtoData: new FetchAnuncios_1.AnunciosData, seguimientoList: [] };
        var dtoid = _this.props.match.params["id"];
        var tipo = _this.props.match.params["tipo"];
        console.log(tipo);
        if (tipo == "review") {
            fetch(historialRev + dtoid, {
                method: 'GET',
                headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                _this.setState({ seguimientoList: data });
            });
        }
        else {
            fetch(historial + dtoid, {
                method: 'GET',
                headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                _this.setState({ seguimientoList: data });
            });
        }
        // This will set state for Edit employee
        if (dtoid > 0) {
            if (tipo == "review") {
                fetch(revisor + dtoid, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                })
                    .then(function (response) {
                    _this.setState({ status: response.status });
                    return response.json();
                })
                    .then(function (data) {
                    _this.setState({ title: "Edit", loading: false, dtoData: data['anuncio'], visor: tipo });
                });
            }
            else {
                fetch(anuncio + dtoid, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                })
                    .then(function (response) {
                    _this.setState({ status: response.status });
                    return response.json();
                })
                    .then(function (data) {
                    _this.setState({ title: "Edit", loading: false, dtoData: data, visor: tipo });
                });
            }
        }
        _this.onDismiss = _this.onDismiss.bind(_this);
        return _this;
        // This binding is necessary to make "this" work in the callback  
    }
    VerHistorial.prototype.onDismiss = function () {
        this.setState({ visible: false });
    };
    VerHistorial.prototype.handleEdit = function (id) {
        this.props.history.push("/creator/anuncios/edit/" + id);
        /*console.log(id);*/
    };
    VerHistorial.prototype.handleCancel = function (id) {
        this.props.history.push("/ver-comunicados" + id);
    };
    VerHistorial.prototype.end = function () {
        espolAds_1.expiro();
        this.props.history.push('/general/principal');
    };
    VerHistorial.prototype.render = function () {
        var contents = (this.state.status == 0)
            ? React.createElement("div", null,
                React.createElement("h5", { className: "title" }, "Loading...."),
                React.createElement("div", { className: "loader" }))
            : (this.state.status != 200 && this.state.status != 201) ? this.end()
                : this.renderHistorial(this.state.seguimientoList);
        return React.createElement("div", null,
            React.createElement("div", { id: "top" }),
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, "HISTORIAL ESTADO")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    // Returns the HTML Form to the render() method.  
    VerHistorial.prototype.renderHistorial = function (seguimientoList) {
        var _this = this;
        var getLastArrItem = function (arr) {
            var lastItem = arr[arr.length - 1];
            return lastItem;
        };
        var estiloR = {
            border: '1.5px solid rgb(201,22,22)',
        };
        var estiloP = {
            border: '1.5px solid rgb(143,189,33)',
        };
        var estiloU = {
            border: '1.5px solid rgb(30,154,146)',
        };
        var estiloE = {
            border: '1.5px solid rgb(0,0,0)',
        };
        var estiloA = {
            border: '1.5px solid rgb(35,41,164)',
        };
        var estiloB = {
            border: '1.5px solid rgb(255,255,255)',
        };
        var Rechazado = getLastArrItem(this.state.seguimientoList);
        console.log(Rechazado);
        var tipo = this.state.visor;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardHeader, null,
                            React.createElement("h6", { className: "title col-md-10" },
                                tipo == "review" ? 'Aprobación' : 'Mis Comunicados',
                                "/ \u00A0",
                                this.state.dtoData.txTitulo)),
                        React.createElement(reactstrap_1.CardBody, null,
                            React.createElement(reactstrap_2.Alert, { color: "danger", isOpen: this.state.visible, toggle: this.onDismiss, style: { fontSize: "1.3vw" } },
                                React.createElement(io5_1.IoAlertCircleOutline, { size: '2vw' }),
                                "\u00A0 Al dar clic en los puntos rojos del historial, se accede a la retroalimentaci\u00F3n para hacer las correcciones."),
                            React.createElement("div", { style: { height: '20vh' } },
                                React.createElement("div", { className: "timeline" },
                                    React.createElement("div", { className: "timeline-progress" }),
                                    React.createElement("div", { className: "timeline-items" }, this.state.seguimientoList.map(function (item, i) { return (React.createElement("div", { key: item.idSecuencia, className: item.bdEstado == 'R' ? "timeline-item-R" : "timeline-item", onClick: function (id) { return _this.abrirModal(item.idAnuncio, item.bdEstado, item.idSecuencia); } },
                                        React.createElement("div", { className: "timeline-content" },
                                            React.createElement(reactstrap_1.Card, { style: item.bdEstado == 'R' ? estiloR : item.bdEstado == 'P' ? estiloP : item.bdEstado == 'A' ? estiloA : item.bdEstado == 'B' ? estiloB : item.bdEstado == 'U' ? estiloU : item.bdEstado == 'E' ? estiloE : null },
                                                React.createElement(reactstrap_1.CardBody, null,
                                                    React.createElement(reactstrap_1.CardTitle, null,
                                                        i + 1,
                                                        "\u00A0-\u00A0",
                                                        item.bdEstado == 'R' ? 'Rechazado' : item.bdEstado == 'P' ? 'Pendiente' : item.bdEstado == 'A' ? 'Aprobado' : item.bdEstado == 'B' ? 'Borrador' : item.bdEstado == 'U' ? 'Publicado' : item.bdEstado == 'E' ? 'Expirado' : null),
                                                    React.createElement(reactstrap_1.CardText, null, item.bdEstado == 'R' ? React.createElement("strong", null, item.txObservacion.substring(0, 23) + "...") : item.bdEstado == 'P' ? 'Enviado' : item.bdEstado == 'A' ? 'Aprobado por Revisor' : item.bdEstado == 'B' ? 'No enviado.' : item.bdEstado == 'U' ? 'Publicado por sistema.' : item.bdEstado == 'E' ? 'Paso fecha de vigencia.' : null),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        "Fecha: ",
                                                        item.dtSeguimiento == null ? null : item.dtSeguimiento.split("T")[0],
                                                        React.createElement("br", null),
                                                        "Hora: ",
                                                        item.dtSeguimiento == null ? null : item.dtSeguimiento.split("T")[1].substring(0, 5))))))); }))))))),
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardHeader, null,
                            React.createElement("h6", null, "Bienvenido a Historial de estado")),
                        React.createElement(reactstrap_1.CardBody, null,
                            React.createElement("p", null, "En esta opci\u00F3n podr\u00E1s: "),
                            React.createElement("ul", null,
                                React.createElement("li", null, "Observar los \u00FAltimos 5 estados por los que pas\u00F3 tu comunicado."),
                                React.createElement("li", null, "Acceder a la retroalimentaci\u00F3n de los revisores cuando rechacen tus comunicados."),
                                React.createElement("li", null, "Visualizar el flujo de los cambios por los que ha pasado tu comunicado.")))))),
            React.createElement(reactstrap_2.Modal, { isOpen: this.state.abierto },
                React.createElement(reactstrap_2.ModalHeader, null, "Informaci\u00F3n"),
                React.createElement(reactstrap_2.ModalBody, null,
                    React.createElement("p", null, "Comentario: "),
                    React.createElement("strong", null, this.state.TargetSeg)),
                React.createElement(reactstrap_2.ModalFooter, null,
                    this.state.visor == "review" ? React.createElement(React.Fragment, null) : React.createElement("button", { className: "btn-info btn-round", onClick: function () { return _this.handleEdit(_this.state.idTarget); } }, "Editar"),
                    React.createElement("button", { className: "btn-success btn-round", onClick: function () { return _this.cerrarModal(); } }, "Cancelar")))));
    };
    return VerHistorial;
}(React.Component));
exports.VerHistorial = VerHistorial;
//# sourceMappingURL=VerHistorial.js.map